import { ServiceTypesEntity } from "@/entities/ServiceTypesEntity.js";
import { apiRequest } from "@/services/api/apiClient.js";

const entity = new ServiceTypesEntity();
export async function getServiceTypes({ page = 1, limit = 10, ...filters } = {}) {
    return apiRequest({
        client: window.API_CHECKIN,
        method: "get",
        url: entity.endpoints.list,
        params: { page, limit, ...filters },
    });
}

export async function getServiceTypesById({id}) {
    return apiRequest({
        client: window.API_CHECKIN,
        method: "get",
        url: entity.getUrl(entity.endpoints.get, { id }),
    });
}

export async function createServiceTypes(data) {
    return apiRequest({
        client: window.API_CHECKIN,
        method: "post",
        url: entity.endpoints.create,
        body: data,
    });
}

export async function saveServiceTypes(data) {
    const isUpdate = !!data.id;
    let url = isUpdate
        ? entity.getUrl(entity.endpoints.get, { id: data.id })
        : entity.endpoints.create;

    const response = await apiRequest({
        client: window.API_CHECKIN,
        method: isUpdate ? "put" : "post",
        url,
        body: data,
    });

    if(response.status !== data.status && isUpdate) {
        const statusChange = data.status ? 'activate' : 'deactivate';
        let urlStatusChange = entity.getUrl(entity.endpoints[statusChange], { id: data.id });

        await apiRequest({
            client: window.API_CHECKIN,
            method: "put",
            url: urlStatusChange,
            body: {
                name
            },
        });
    }

    return response;
}

export async function deleteServiceTypes({id}) {
    const url = entity.getUrl(entity.endpoints.delete, { id });
    return apiRequest({
        client: window.API_CHECKIN,
        method: "delete",
        url,
    });
}
